const feedTypes = {
  share: "SHARE",
  image: "IMAGE",
  video: "VIDEO"
}

export default feedTypes;